export default function () {
	const debug = false;
	const modal = document.getElementById('js-modal-feature-large');
	const modalClose = modal.querySelector('.modal-feature-large__overlay-close');
	const modalVideoContainer = modal.querySelector('.modal-feature-large__overlay-video-container');
	const blocks = Array.from(document.querySelectorAll('.block--four-column-feature-large'));
	let modalOpened = false;

	function fourColumnFeatureLargeOverlay() {
		blocks.forEach(block => {
			if (debug) console.log('found a block');
			const clickTargets = Array.from(block.querySelectorAll('.four-column-feature-large--item--card-area'));

			clickTargets.forEach(clickTarget => {
				if (debug) console.log('card instance(s) found');
				clickTarget.addEventListener('click', function(evt) {
					evt.preventDefault();
					if (debug) console.log('card clicked');

					const targetData = this.querySelector('.four-column-feature-large--item--card');

					if (targetData.dataset.type === 'card') {
						const modalOverlay = modal.querySelector('.modal-feature-large__overlay');
						modalOverlay.querySelector('.modal-feature-large__overlay-title').textContent = targetData.dataset.title;
						modalOverlay.querySelector('.modal-feature-large__overlay-thumbnail').src = targetData.dataset.thumbnailUrl;
						modalOverlay.querySelector('.modal-feature-large__overlay-thumbnail').alt = targetData.dataset.thumbnailAlt;
						modalOverlay.querySelector('.modal-feature-large__overlay-feature-title').textContent = targetData.dataset.featureTitle;
						modalOverlay.querySelector('.modal-feature-large__overlay-feature-description').innerHTML = targetData.dataset.featureDescription;
						modalOverlay.querySelector('.modal-feature-large__overlay-feature-subheading').textContent = targetData.dataset.featureSubheading;
						const featureButton = modalOverlay.querySelector('.modal-feature-large__overlay-feature-button');

						if (targetData.dataset.featureButtonTitle) {
							featureButton.textContent = targetData.dataset.featureButtonTitle;
							featureButton.href = targetData.dataset.featureButtonUrl;
							featureButton.title = targetData.dataset.featureButtonTitle;

							if (targetData.dataset.featureButtonTarget) {
								featureButton.target = targetData.dataset.featureButtonTarget;
							} else {
								featureButton.target = '_self';
							}

							modalOverlay.querySelector('.modal-feature-large__overlay-button').style.display = 'block';
						} else {
							modalOverlay.querySelector('.modal-feature-large__overlay-button').style.display = 'none';
						}

						// Show/hide what's needed
						Array.from(modalOverlay.querySelectorAll('.modal-feature-large__overlay-text, .modal-feature-large__overlay-image')).forEach(el => el.style.display = 'block');
					} else if (targetData.dataset.type === 'oembed') {
						let iframeContent = this.querySelector('.oembed').innerHTML.trim();
						if (debug) console.log('start: ', iframeContent);

						if (iframeContent.startsWith('<!-- ')) {
							iframeContent = iframeContent.substring('<!-- '.length);
						}
						if (iframeContent.endsWith(' -->')) {
							iframeContent = iframeContent.substring(0, iframeContent.length - ' -->'.length);
						}
						if (debug) console.log('cleaned: ', iframeContent);
						modalVideoContainer.innerHTML = iframeContent;

						// Show/hide what's needed
						Array.from(modal.querySelectorAll('.modal-feature-large__overlay-text, .modal-feature-large__overlay-image')).forEach(el => el.style.display = 'none');
						modal.querySelector('.modal-feature-large__overlay-video').style.display = 'block';
					}

					modal.style.display = 'flex';
					document.querySelector('html').classList.add('modal-is-open');

					setTimeout(() => {
						modal.classList.add('active');
						modalOpened = true;
					}, 100);
				});
			});
		});
	}

	function resetModalFields() {
		const modalOverlay = modal.querySelector('.modal-feature-large__overlay');
		Array.from(modalOverlay.querySelectorAll('.modal-feature-large__overlay-text, .modal-feature-large__overlay-image, .modal-feature-large__overlay-video, .modal-feature-large__overlay-button')).forEach(el => el.style = '');
		modalOverlay.querySelector('.modal-feature-large__overlay-title').textContent = '';
		modalOverlay.querySelector('.modal-feature-large__overlay-thumbnail').src = '';
		modalOverlay.querySelector('.modal-feature-large__overlay-thumbnail').alt = '';
		modalOverlay.querySelector('.modal-feature-large__overlay-feature-title').textContent = '';
		modalOverlay.querySelector('.modal-feature-large__overlay-feature-description').innerHTML = '';
		modalOverlay.querySelector('.modal-feature-large__overlay-feature-subheading').textContent = '';
		const featureButton = modalOverlay.querySelector('.modal-feature-large__overlay-feature-button');
		featureButton.textContent = '';
		featureButton.href = '';
		featureButton.title = '';
		featureButton.target = '';

		modalVideoContainer.innerHTML = '';
	}

	modalClose.addEventListener('click', function(e) {
		handleClickClose(e);
	});

	function handleClickClose(evt) {
		evt.preventDefault();
		if (debug) console.log('close button clicked');

		modal.classList.remove('active');
		document.querySelector('html').classList.remove('modal-is-open');

		setTimeout(() => {
			modal.style.display = 'none';
			resetModalFields();
			modalOpened = false;
		}, 300);
	}

	// Function to handle clicks outside the modal
	function handleOutsideClick(evt) {
		if (modalOpened                   // the modal is opened
			&& modal !== evt.target       // is not the modal
			// && blocks !== evt.target      // is not the ...
		) {
			debug ? console.log('User clicked outside the modal while it was open') : false;
			handleClickClose(evt);
		}
	}

	fourColumnFeatureLargeOverlay();
}
